"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createProduction: function() {
        return createProduction;
    },
    deleteProduction: function() {
        return deleteProduction;
    },
    duplicateProduction: function() {
        return duplicateProduction;
    },
    generateProductions: function() {
        return generateProductions;
    },
    processSegmentReigns: function() {
        return processSegmentReigns;
    },
    productionComplete: function() {
        return productionComplete;
    },
    productionCompleteBrands: function() {
        return productionCompleteBrands;
    },
    productionCompleteChampionships: function() {
        return productionCompleteChampionships;
    },
    productionCompleteFeuds: function() {
        return productionCompleteFeuds;
    },
    productionCompleteSegments: function() {
        return productionCompleteSegments;
    },
    productionCompleteWrestlers: function() {
        return productionCompleteWrestlers;
    },
    productionSegmentsSimulate: function() {
        return productionSegmentsSimulate;
    },
    resetProductions: function() {
        return resetProductions;
    },
    updateProduction: function() {
        return updateProduction;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
const _feuds = require("./feuds");
const _championships = require("./championships");
const _reigns = require("./reigns");
const _helpers = require("@fedsim/helpers");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createProduction(payload) {
    return {
        type: _types.ADD_PRODUCTION,
        payload
    };
}
function duplicateProduction(payload) {
    return {
        type: _types.DUPLICATE_PRODUCTION,
        payload
    };
}
function updateProduction(payload) {
    return {
        type: _types.UPDATE_PRODUCTION,
        payload
    };
}
function deleteProduction(payload) {
    return {
        type: _types.DELETE_PRODUCTION,
        payload
    };
}
function resetProductions() {
    return {
        type: _types.RESET_PRODUCTIONS
    };
}
function productionCompleteSegments(payload) {
    return {
        type: _types.PRODUCTION_COMPLETE_SEGMENTS,
        payload
    };
}
function productionCompleteWrestlers(payload) {
    return {
        type: _types.PRODUCTION_COMPLETE_WRESTLERS,
        payload
    };
}
function getProductionById(Production, id) {
    const production = Production?.itemsById?.[id];
    return production;
}
function getSegmentsByProduction(Segment, segmentIds = []) {
    const segments = segmentIds.reduce((acc, segmentId)=>{
        const segment = Segment?.itemsById?.[segmentId];
        if (segment?.championshipIds) {
            return [
                ...acc,
                segment
            ];
        } else {
            return acc;
        }
    }, []);
    return segments;
}
function productionComplete(payload) {
    return {
        type: _types.PRODUCTION_COMPLETE,
        payload
    };
}
function productionCompleteBrands(payload) {
    return {
        type: _types.PRODUCTION_COMPLETE_BRANDS,
        payload
    };
}
function productionSegmentsSimulate(payload) {
    return {
        type: _types.PRODUCTION_SEGMENTS_SIMULATE,
        payload
    };
}
function productionCompleteChampionships({ id }) {
    return (dispatch, getState)=>{
        const state = getState();
        const { Production, Segment, Appearance } = state.entitiesv2;
        const production = getProductionById(Production, id);
        const segments = getSegmentsByProduction(Segment, production.segmentIds);
        if (segments?.length > 0) {
            segments.forEach((segment)=>{
                const appearances = Object.values(Appearance?.itemsById)?.filter((item)=>item.segmentId === segment.id);
                const wrestlerIds = appearances.filter((item, index)=>item.winner && appearances.indexOf(item) === index).map((item)=>item.wrestlerId);
                segment?.championshipIds?.forEach((id)=>{
                    dispatch((0, _championships.updateChampionship)({
                        id,
                        wrestlerIds
                    }));
                });
            });
        }
    };
}
function productionCompleteFeuds({ id }) {
    return (dispatch, getState)=>{
        const state = getState();
        const { Production, Segment } = state.entitiesv2;
        const production = getProductionById(Production, id);
        const segments = getSegmentsByProduction(Segment, production.segmentIds);
        const feudIds = segments.reduce((acc, segment)=>{
            const feudId = segment?.feudId;
            return [
                ...acc,
                feudId
            ];
        }, []);
        if (feudIds?.length) {
            feudIds.forEach((id)=>{
                dispatch((0, _feuds.feudNextStage)({
                    id
                }));
            });
        }
    };
}
function processSegmentReigns(payload) {
    const { id, date = null } = payload;
    return (dispatch, getState)=>{
        const state = getState();
        const { Championship, Segment, Reign, Game, Appearance, Production } = state.entitiesv2;
        const production = getProductionById(Production, id);
        const segments = getSegmentsByProduction(Segment, production.segmentIds);
        if (segments?.length > 0) {
            segments.forEach((segment)=>{
                if (segment.championshipIds.length > 0) {
                    const appearances = Object.values(Appearance.itemsById)?.filter((item)=>item.segmentId === segment.id);
                    if (!appearances) return;
                    const activeDate = date || Object.values(Game.itemsById)[0]?.date;
                    const championships = Object.values(Championship.itemsById)?.filter((item)=>segment.championshipIds.includes(item.id));
                    if (!championships) return;
                    championships.forEach((championship)=>{
                        const { id: championshipId } = championship;
                        const reign = Object.values(Reign?.itemsById)?.find((item)=>item.championshipId === championshipId && item.endDate === null);
                        const winnerIds = appearances?.filter((item)=>item.winner && !item.manager).map((item)=>item.wrestlerId) || [];
                        const newChampions = reign?.wrestlerIds && !(0, _helpers.arraysEqual)(reign.wrestlerIds, winnerIds);
                        const processReignAction = (dispatch)=>{
                            // existing reign, new champions
                            if (reign && newChampions) {
                                dispatch((0, _reigns.updateReign)({
                                    id: reign.id,
                                    endDate: activeDate
                                }));
                                dispatch((0, _reigns.startReign)({
                                    championshipId,
                                    segmentId: segment.id,
                                    wrestlerIds: winnerIds,
                                    startDate: activeDate
                                }));
                            // existing reign, same champions
                            } else if (reign && !newChampions) {
                                const defenses = reign.defenses + 1;
                                dispatch((0, _reigns.updateReign)({
                                    id: reign.id,
                                    defenses
                                }));
                            // no existing reign
                            } else if (!reign && winnerIds.length > 0) {
                                dispatch((0, _reigns.startReign)({
                                    championshipId,
                                    segmentId: segment.id,
                                    wrestlerIds: winnerIds,
                                    startDate: activeDate
                                }));
                            }
                        };
                        return processReignAction(dispatch);
                    });
                }
            });
        }
    };
}
function generateProductions(payload) {
    return {
        type: _types.GENERATE_PRODUCTIONS,
        payload
    };
}
